import {z} from 'zod';
import {defineToolRegistryManifest} from '../../types/base-tool-types';

const toolName = 'list-webhooks' as const;

// Empty object since we don't need arguments - site comes from context
const argumentZod = z.object({});

export const listWebhooksManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'List webhooks',
  family: 'webhooks',
  llmTool: {
    name: toolName,
    description:
      'Lists all webhooks for the current site, including their trigger types, URLs, and status.',
    inputSchema: argumentZod,
  },
  type: 'server',
  permission: [{resource: 'SiteWebhook', action: 'manage'}],
  confirmBeforeExecuting: false,
  isConcurrencySafe: () => true,
  isReadOnly: () => true,
});

export type ListWebhooksArgumentType = z.infer<typeof argumentZod>;
